export default __webpack_public_path__ + "static/new7-04-e780c15f5dccfe07f0ad339687a59b5a.jpg";